import axios from './providers/axios';

const marketplaceCommentService = {
    getAllComments(params = {}) {
        return axios.get(`/v1/admin/marketplace/comment/store`, { params });
    },
    getCommentByProductId(id) {
        return axios.get(`/v1/admin/marketplace/comment/getCommentByProduct/${id}`);
    },
    deleteComment(id) {
        return axios.delete(`/v1/admin/comment/delete/${id}`);
    },
    getCommentById(id) {
        return axios.get(`/v1/admin/comment/getFromId/${id}`);
    }
}

export default marketplaceCommentService;
